import { Method } from 'axios';
import { axios, axiosPublic, axiosPrivate } from './axiosClient';
import {
  userRegisterActions,
  userSigninActions,
  userDetailsActions,
  userUpdateProfileActions,
  userUpdateActions,
  userListActions,
  userDeleteActions,
  userTopSellerListActions,
} from '../slice/UserSlice';
import { Storage } from '../utils';
import { KEY } from '../constants';
import { MAIL_SERVER, HEADERS } from 'src/constants';

export const register = (name: string, email: string, password: string, confirmPassword: string) =>
  axiosPublic([userRegisterActions], {
    successAction: userSigninActions._SUCCESS,
    successHandler: (_data) => (Storage[KEY.USER_INFO] = _data),
  })('post', '/api/users/register', {
    name,
    email,
    password,
    confirmPassword,
  });

export const signin = (email: string, password: string) =>
  axiosPublic([userSigninActions], { successHandler: (_data) => (Storage[KEY.USER_INFO] = _data) })(
    'post',
    '/api/users/signin',
    {
      email,
      password,
    }
  );

export const signout =
  () =>
  async (dispatch: AppDispatch, getState: FnType): Promise<void> => {
    // best-effort: revoke the refresh token server-side so it can't be reused,
    // but a network hiccup shouldn't block signing out locally
    const token = getState()?.userSignin?.userInfo?.token;
    if (token) {
      try {
        await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/users/logout', null, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch {
        // ignore - local sign-out still proceeds below
      }
    }

    Storage[KEY.USER_INFO] = '';
    Storage[KEY.CART_ITEMS] = '';
    Storage[KEY.SHIPPING_ADDRESS] = '';
    dispatch(userSigninActions._RESET(''));
    document.location.href = '/signin';
  };

export const publicDetailsSeller = (_id: string) => axiosPublic([userDetailsActions])('get', `/api/users/${_id}`);

export const detailsUser = (_id: string) => axiosPrivate([userDetailsActions])('get', `/api/users/${_id}`);

/* Types: UserType for contact form, ReqLogin for profile update with request login info. */
export const updateUserProfile = (user: UserType & ReqLogin, method: Method = 'patch') =>
  axiosPrivate([userUpdateProfileActions], {
    successAction: method !== 'patch' ? userDetailsActions._SUCCESS : userSigninActions._SUCCESS,
    successHandler: (userInfo) => (Storage[KEY.USER_INFO] = userInfo),
  })(method, `/api/users/profile`, user);

export const updateUser = (user: UserType) =>
  axiosPrivate([userUpdateProfileActions, userUpdateActions])('put', `/api/users/${user._id}`, user);

export const listUsers = () => axiosPrivate([userListActions])('get', '/api/users');

export const deleteUser = (_id: string) => axiosPrivate([userDeleteActions])('delete', `/api/users/${_id}`);

export const listTopSellers = () => axiosPublic([userTopSellerListActions])('get', '/api/users/top-sellers');

/* this contact will not be sent to redux store since MAIL_SERVER is different origin */
export const sendContactMessage =
  (contactData: ContactType, setStatus: SetStateType<StatusType>) => async (dispatch: AppDispatch) => {
    setStatus({ loading: true, msg: 'Your message is being sent.' });
    try {
      // withCredentials: false - MAIL_SERVER is a third party, not our own
      // backend; axios.defaults.withCredentials = true (axiosClient.ts) is
      // global and would otherwise attach it here too, which a browser
      // rejects outright against a wildcard Access-Control-Allow-Origin.
      await axios.post(MAIL_SERVER, contactData, {
        headers: { ...HEADERS, body: JSON.stringify(contactData) },
        withCredentials: false,
      });
      setStatus({ msg: 'Thank you! Your message has been sent.' });
    } catch (error) {
      if (error instanceof Error) setStatus({ error: error.message });
    }
    dispatch(userUpdateProfileActions._RESET(''));
  };
